import { type Ref } from 'react';
import { Search } from 'lucide-react';

import { Button } from '@/components/common/Button/Button';
import { classNames } from '@/utils/classNames';
import { QUESTION_MAX_LENGTH } from '@/utils/questionText';

import styles from '@/styles/home.module.css';

type QuestionInputProps = {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  inputRef?: Ref<HTMLTextAreaElement>;
  skeleton?: boolean;
};

export function QuestionInput({
  value,
  onChange,
  onSubmit,
  isLoading = false,
  disabled = false,
  className,
  inputRef,
  skeleton = false,
}: QuestionInputProps): JSX.Element {
  const isEmpty = value.trim().length === 0;
  const isDisabled = disabled || isLoading;

  return (
    <form
      className={classNames(styles.questionSection, className)}
      aria-busy={skeleton || undefined}
      onSubmit={(event) => {
        event.preventDefault();

        if (!isEmpty && !isDisabled) {
          onSubmit();
        }
      }}
    >
      <div className={styles.questionField}>
        <textarea
          ref={inputRef}
          id="home-question-input"
          className={classNames(styles.questionInput, skeleton && styles.questionInputSkeleton)}
          rows={4}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Ex.: O que ele propõe para reduzir a violência urbana?"
          maxLength={QUESTION_MAX_LENGTH}
          disabled={isDisabled}
          aria-describedby="home-question-counter"
        />

        <span id="home-question-counter" className={styles.questionCounter} aria-live="polite">
          {value.length} / {QUESTION_MAX_LENGTH}
        </span>
      </div>

      <div className={styles.questionActions}>
        <Button type="submit" disabled={isEmpty || isDisabled}>
          <Search size={16} />
          Perguntar
        </Button>
      </div>
    </form>
  );
}
